"use client"

import React from "react"
import { SessionProvider, useSession } from "next-auth/react"
import { AppContextProvider } from "@app/components/AppContext"
import { Header } from "@app/components/Header"
import { ChonkyInit } from "../app-components/FileBrowser/ChonkyInit"
import { Sidebar } from "src/app-components/Navbar"
import { RootModalProvider } from "@app/components/RootModal/RootModal"
import { BarrelRollProvider } from "../app-components/BarrellRoll/BarrellRollContext"
import { MainBody } from "../app-components/MainBody"
import { Login } from "@fsg/gui-bits"
import { CommandPalette } from "../app-components/CommandPalette/CommandPalette"
import { SidebarProvider } from "@app/components/ui/sidebar"
import { AppSidebar } from "@app/components/AppSidebar"

function ClientContent({ children }: { children: React.ReactNode }) {
  const { data: session, status } = useSession()

  if (status === "loading") {
    return null
  }

  if (!session) {
    return <Login />
  }

  return (
    <AppContextProvider session={session}>
      <BarrelRollProvider>
        <RootModalProvider>
          <ChonkyInit />
          <CommandPalette />
          <SidebarProvider sidebarWidth="14.0625rem">
            <AppSidebar />
            <div
              className="w-full h-screen overflow-hidden bg-white flex flex-col"
              id="app-layout-wrapper"
            >
              <Header />
              {children}
            </div>
            <ChonkyInit />
          </SidebarProvider>
        </RootModalProvider>
      </BarrelRollProvider>
    </AppContextProvider>
  )
}

const RootLayoutClient = ({ children }: { children: React.ReactNode }) => {
  return (
    <SessionProvider>
      <ClientContent>{children}</ClientContent>
    </SessionProvider>
  )
}

export default RootLayoutClient
